import { Link } from "react-router-dom";

export default function ConsentCTA() {
  return (
    <section
      id="contact"
      className="bg-surface text-center py-[5.5rem] border-t border-line"
    >
      <div className="container mx-auto max-w-[1140px] px-4">
        <p className="inline-block text-[0.78rem] font-semibold tracking-[0.12em] uppercase text-teal mb-[0.85rem]">
          Get started
        </p>
        <h2 className="font-bricolage text-[clamp(1.8rem,3vw,2.3rem)] mb-[0.85rem] text-ink">
          See Consent Management on your data.
        </h2>
        <p className="text-slate max-w-[34rem] mx-auto mb-7">
          Walk through employee, vendor and partner consents, Consent Variance,
          Email/WhatsApp tracking and full DSAR — with your team.
        </p>
        <div className="flex flex-wrap justify-center gap-3">
          <a
            href="mailto:sales@onedpdp.com"
            className="inline-block bg-teal hover:bg-teal-bright text-white font-semibold rounded px-10 py-4 text-lg transition-all hover:-translate-y-px"
          >
            Request a demo
          </a>
          <Link
            to="/explore"
            className="inline-block bg-transparent text-teal border-[1.5px] border-teal hover:bg-teal-soft font-semibold rounded px-8 py-4 text-lg transition-all"
          >
            Back to platform
          </Link>
        </div>
      </div>
    </section>
  );
}
